<script>
import StatusBar from '@/V2/components/status/StatusBar.vue';
import { RISKS_CONFIG } from '@/constants/analyst-config';
import UrlsDisplayer from '@/V2/components/UrlsDisplayer.vue';

export default {
  components: { StatusBar, UrlsDisplayer },
  props: {
    signal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      RISKS_CONFIG,
    };
  },
};
</script>

<template>
  <div
    class="customer-fraud-verification-details d-flex flex-row align-items-center"
  >
    <div class="body d-flex flex-column i-gap-9">
      <status-bar
        :state="signal.status"
        :label="RISKS_CONFIG[signal.value.result].label"
      ></status-bar>
      <div class="text d-flex flex-column i-gap-4">
        <div class="title i-text-button-3 i-text-neutral-120">Analysis</div>
        <div class="rationale i-text-body-3 i-text-neutral-120">
          {{ signal.value?.rationale }}
        </div>
      </div>
      <urls-displayer :urls="signal.value?.urls" />
    </div>
  </div>
</template>
